const GAMTargeting = {
  DemographicsKey: "csat",
};

export default GAMTargeting;
